import React, { FC } from 'react';
import styles from './styles.module.css';
import { SearchIcon } from './search-icon';

export interface SearchBarProps
  extends Omit<React.FormHTMLAttributes<HTMLFormElement>, 'onSubmit'> {
  placeholder?: string;
  value?: string;
  buttonLabel?: string;
  onClickSearch?: () => void;
  onSearch?: (value: string) => void;
  onSubmitSearch?: () => void;
  onChangeText?: (text: string) => void;
  tone?: 'default' | 'inverted';
  size?: 'md' | 'lg';
  submitIcon?: React.ReactNode;
}

export const SearchBar: FC<SearchBarProps> = ({
  placeholder = 'Buscar...',
  value = '',
  buttonLabel = 'Filtrar',
  onClickSearch,
  onSearch,
  onSubmitSearch,
  onChangeText,
  tone = 'default',
  size = 'lg',
  submitIcon,
  className,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (onSubmitSearch) {
      onSubmitSearch();
      return;
    }
    if (onClickSearch) {
      onClickSearch();
      return;
    }
    onSearch?.(value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeText?.(event.target.value);
  };

  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const formClassName = [
    styles.searchContainer,
    tone && styles[`tone-${tone}`],
    size && styles[`size-${size}`],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <form className={formClassName} onSubmit={handleSubmit} {...rest}>
      <div className={styles.searchWrapper}>
        <SearchIcon className={styles.searchIcon} aria-hidden="true" />
        <input
          type="search"
          name="search"
          className={styles.searchInput}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={handleInputKeyDown}
          aria-label={ariaLabel}
        />
      </div>

      <button type="submit" className={styles.searchButton}>
        {submitIcon}
        <span>{buttonLabel}</span>
      </button>
    </form>
  );
};
